import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d64079fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-extra__quantity-list" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}

import BookingExtraQuantity from "@/components/bookingflow/steps/extras/BookingExtraQuantity.vue";
import BaseAlert from "@/components/base/BaseAlert.vue";
import { ExtraInnerSection } from "@/models/www/ExtrasComponent";


interface Props {
  section: ExtraInnerSection;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingExtraQuantityList',
  props: {
    section: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.section?.resources)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.resources, (resource, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col--12 col-md--6",
              key: index
            }, [
              _createVNode(BookingExtraQuantity, {
                extra: resource,
                index: index
              }, null, 8, ["extra", "index"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})